import { Form } from 'formik';
import styled from 'styled-components/macro';
import { fontSize, lineHeight, space } from '../../../theme/tokens';
import { FieldGroup } from '../../common/elements/Form';
import { DeleteIconButton } from '../../common/elements/Staff';

export const AddAssessmentContainer = styled.section`
  text-align: center;
`;

export const AssessmentForm = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space[3]};
  padding: ${space[4]};
`;

export const InfoText = styled.p`
  margin: ${space[4]} 0 0;
  font-size: ${fontSize.md};
  line-height: ${lineHeight.normal};
  color: ${({ theme }) => theme.headerColour};
`;

export const SelectContainer = styled(FieldGroup)`
  background: ${({ theme }) => theme.appBackground};
  padding: 0;
  margin: ${space[3]} 0;
`;

export const CloseIconButton = styled(DeleteIconButton)`
  margin: 0 ${space[4]} 0 auto;
`;

export * from '../../common/elements/Assessments';
export * from '../../common/elements/Form';
export * from '../../common/elements/Staff';
export * from '../../common/elements/Students';
